<template>
  <div class="">
    <el-select
      v-model="categoryModel"
      @change="categoryChanged"
      autocomplete="new-password"
      :placeholder="placeholder ? placeholder : $t('COMMON.CATEGORIES')"
      :filterable="filterable"
      :multiple="true"
      :disabled="disabled"
      remote
      :remote-method="getCategories"
      :loading="loading"
      collapse-tags
    >
      <el-option
        v-if="showAll"
        :value="null"
        :label="placeholder ? placeholder : $t('COMMON.CATEGORIES')"
      >
      </el-option>
      <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
      </el-option>
      <el-option
        v-for="(category, key) in categoryList"
        :key="key"
        :value="category.id"
        :label="`${category.name}`"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { Option, Select } from "element-ui";
import { difference } from "lodash";

export default {
  name: "categories-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    categories: {
      type: Array,
      default: () => [],
      description: "Warehouse id",
    },
    filterIdsNotIn: {
      type: Array,
      default: () => [],
      description: "Warehouse not in list id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    placeholder: {
      type: String,
      default: null,
      description: "Placeholder",
    },
  },

  data() {
    return {
      categoryModel: [...this.categories].map((item) => item.id),
      categoryList: [],
      loading: false,
    };
  },

  setup() {},

  created() {
    this.getCategories(null, this.category);
  },

  methods: {
    async getCategories(query = null, ids = null) {
      try {
        this.loading = true;
        let params = {
          sort: "-created_at",
          filter: {
            ...(query ? { search: query } : {}),
            ...(ids?.length ? { ids: ids.map((item) => item.id) } : {}),
          },
          page: {
            number: 1,
            size: 999,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }

        if (this.filterIdsNotIn.length > 0) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              idsNotIn: this.filterIdsNotIn,
            },
          };
        }
        await this.$store.dispatch("categories/list", params);
        const categoriesArr = await this.$store.getters["categories/list"];
        this.categoryList = {};
        categoriesArr.forEach((category) => {
          this.categoryList[category.id] = category;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    categoryChanged(categories) {
      this.$emit(
        "categoryChanged",
        [...categories].map((item) => ({ type: "categories", id: item }))
      );
    },
  },

  watch: {
    categories(categories) {
      if (categories?.length) {
        const categoriesData = categories.map((item) => item.id);
        if (difference(categoriesData, this.locationsModel).length !== 0) {
          this.categoryModel = categoriesData;
        }
      } else {
        this.categoryModel = [];
      }
    },
    filterOrganization(filterOrganization) {
      this.getCategories();
    },
    filterIdsNotIn(filterIdsNotIn) {
      this.getCategories();
    },
  },
};
</script>
